
import { Dispatch } from "redux"
import ApplicationState from "../../../../../../ApplicationState"
import IState from "../../../../../Util/IState"
import HeaderState, { Hstate } from "../../State/HeaderState"
import HeaderUI from "./HeaderUI"
import { connect } from "react-redux"
import IDispatcher from "../../../../../Util/IDispatcher"
import HeaderDispatch from "./model"
import { ActionType as RouterActionType} from "../../../Main/Router/Actions/ActionTypes"
import { ActionType } from "../../Actions/ActionTypes"

const mapStateToProps = (state: ApplicationState): IState<Hstate> => {
    return {
        state: {
            header : state.header,
            user : state.home.user
        }
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<HeaderDispatch> => ({
    dispatcher: {
        payment: (isOpen : boolean) => { dispatch({ type: ActionType.OPEN_PAYMENT_DIALOG, isOpen: isOpen }) },
        mainPage : () => {dispatch({type : RouterActionType.MAIN_UI_DASHBOARD})}
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderUI)